module.exports = __webpack_public_path__ + "img/helpReports.e0781f3e.svg";